import useContainer from '@admin/hooks/use_container'
import PropTypes from 'prop-types'
import Badge from './badge'
import React from 'react'

const BadgeContainer = (props, context) => {

  const container = props.count ? useContainer({
    display_name: 'badge',
    resources: {
      count: props.count(props, context)
    }
  }) : {}

  const mergedProps = {
    ...props,
    count: container?.values?.count || null
  }

  return <Badge { ...mergedProps } />

}

BadgeContainer.contextTypes = {
  admin: PropTypes.object,
  provider: PropTypes.object
}

BadgeContainer.propTypes = {
  count: PropTypes.func
}

export default BadgeContainer